// TODO: エラーメッセージをIndexでIndexを探し、そのIndexでメッセージを取る手段は余りにも可読性に欠けるので、リファクタすること。
let default_msg = {
    'msg_common_01': 'Failed to get the data.',
    'msg_login_01': 'Sign in failed',
    'msg_reset_pass_01': 'Limit exceeded. Please try again in a while.',
    'msg_reset_pass_02': 'The account you have entered does not exist.',
    'msg_reset_pass_03': 'An error has occurred. Please try again in a few minutes.',
    'msg_reset_pass_04': 'Please enter Vin No.',
    'msg_reset_pass_05': 'An error has occurred. Please contact the administrator.',
    'msg_set_new_pass_01': 'The authentication code is wrong.',
    'msg_set_new_pass_02': "Sign up failed with errors below.",
    'msg_set_new_pass_03': "An unexplained error has occurred.",
    'msg_set_new_pass_04': "Failed to login after resetting password.",

    'msg_validate_01': 'Please select the date before "To" with "From".',
    'msg_limit_exceeded':"Too many attempts. Please try again after a while."
}

export const msgs = default_msg;




// WEBPACK FOOTER //
// ./src/js/ErrorMessage.js